var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFliphorizontalselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.384,
    height: 16.678,
    viewBox: "0 0 20.384 16.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-flip",
    "data-name": "Icon material-flip",
    d: "M10.059,20.031H8.206V18.178h1.853ZM6.353,8.912H4.5V7.059H6.353ZM21.178,5.206V18.178a1.859,1.859,0,0,1-1.853,1.853H15.618V18.178h3.706V5.206H15.618V3.353h3.706A1.859,1.859,0,0,1,21.178,5.206ZM6.353,3.353V5.206H4.5A1.859,1.859,0,0,1,6.353,3.353Zm7.412,18.531H11.912V1.5h1.853ZM6.353,16.325H4.5V14.472H6.353ZM10.059,5.206H8.206V3.353h1.853ZM6.353,12.618H4.5V10.765H6.353Zm0,7.412A1.859,1.859,0,0,1,4.5,18.178H6.353Z",
    transform: "translate(21.884 -4.5) rotate(90)",
    fill: "#0072C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFliphorizontalselected);
export default __webpack_public_path__ + "static/media/fliphorizontalselected.ad0b89f272f1f08bb4638c88c68e383d.svg";
export { ForwardRef as ReactComponent };